













import { RadiusOption } from '../marketplace-model'

const radiusFilterOptions = [
  { key: '0 km', value: 0 },
  { key: '+50 km', value: 50 },
  { key: '+100 km', value: 100 },
  { key: '+150 km', value: 150 },
  { key: '+200 km', value: 200 }
]

export default {
  props: {
    value: {
      type: Number,
      default: 50,
      validator: value => radiusFilterOptions.some(item => item.value === value)
    }
  },
  data() {
    return {
      radiusFilterOptions
    }
  },
  computed: {
    radiusOption: {
      get(): Array<RadiusOption> {
        return this.radiusFilterOptions.filter(item => item.value === this.value)
      },
      set(radius: RadiusOption) {
        if (!radius) return
        this.$emit('input', radius.value)
      }
    }
  }
}
